// extracted by mini-css-extract-plugin
export default {"mailButton":"MailButton_mailButton__cf4-k","icon":"MailButton_icon__XLQAM"};